import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { TranslateModule } from "@ngx-translate/core";
import { MaterialModule } from "src/app/material.module";

@Component({
  selector: 'app-appointment-dialog',
  standalone: true,
  imports: [
    MaterialModule,
    TranslateModule
  ],
  templateUrl: './appointment-dialog.component.html',

})
export class AppointmentDialog {
  constructor(
    private dialogRef: MatDialogRef<AppointmentDialog>,
    @Inject(MAT_DIALOG_DATA) public data: {
      message: string;
      title: string;
      cancelText?: string;
      confirmText?: string;
    }
  ) { }

  onConfirm(): void {
    this.dialogRef.close("yes");
  }
}
